var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lesson-sk-wrap"},[(_vm.unSigned || _vm.lessonInfo.lectureRelationship === 3)?_c('span',{staticClass:"lesson-sk-noclick"},[_vm._v(" 去上课 ")]):_c('span',{staticClass:"lesson-sk"},[_c('a',{on:{"click":function($event){return _vm.handleShouke('kejian')}}},[_vm._v("去上课")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }